<template>
    <div class="sustainable-component wage-block-dificulty-level-evaluation">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-block-dificulty-level-evaluation</div>-->


        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-3">Blocknr.</th>
                                <th class="col-3">Blocknamn</th>
                                <th class="col-3">Arbetsuppgifter</th>
                                <th class="col-3">Grad</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in blocks" :key="index">
                                <td valign="middle">
                                    {{item.BlockNumber}}
                                </td>
                                <td valign="middle">
                                    {{item.BlockName}}
                                </td>
                                <td valign="middle">
                                    <a href="javascript:void(0)" @click="openPopup(item.PositionBlockId)">Visa arbetsuppgifter</a>
                                </td>
                                <td>
                                    <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" density="compact" :items="blockGrades" v-model="item.GradeNumber" item-title="Gradeinfo" item-value="GradeNumber" @update:modelValue="changedValue(item)" hide-details></v-select>
                                </td>
                            </tr>
                            <tr>
                                <td class="pr-3" colspan="4" style="text-align:right">
                                    <b>Summa poäng: {{getSum(blocks)}}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <WageBlockDificultyLevelEvaluationPopup ref="dificultyLevelPopup"></WageBlockDificultyLevelEvaluationPopup>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import { getCurrentInstance } from 'vue'
    import WageBlockDificultyLevelEvaluationPopup from './wage-block-dificulty-level-evaluation-popup.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const dificultyLevelPopup = ref(null);

    export default {
        emits: ['updated'],
        name: 'wage-block-dificulty-level-evaluation',
        components: {
            WageBlockDificultyLevelEvaluationPopup,
            CommonSpinner
        },
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            async changedValue(item) {
                this.loading++;
                try {
                    var blockGradeId = this.getBlockGradeId(item.GradeNumber);
                    await WageService.updateJobPositionBlockGrade(item.PositionBlockId, blockGradeId);
                    this.displaySnackBar("Sparat");
                    this.reload();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            getId() {
                return getCurrentInstance().uid;
            },
            openPopup(positionBlockId) {
                this.loading++;
                this.dificultyLevelPopup.open(positionBlockId);
                this.loading--;
            },
            getBlockGradeId(gradeNumber) {
                for (var i = 0; i < this.blockGrades.length; i++) {
                    if (this.blockGrades[i].GradeNumber == gradeNumber)
                        return this.blockGrades[i].BlockGradeId;
                }
                return null;
            },
            async getBlockGrades() {
                this.loading++;
                try {
                    this.blockGrades = await WageService.getBlockGrades()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async reload() {
                this.loading++;
                try {
                    this.blocks = await WageService.getPositionBlockGrade(this.selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            getSum(blocks) {
                var points = 0;
                for (var i = 0; i < blocks.length; i++) {
                    points += blocks[i].Points;
                }
                return points;
            }
        },
        data() {
            return {
                blockGrades:[],
                selectedPosition: null,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                blocks: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.reload();
                this.$emit('positionSelected', newVal)

            }
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            if (this.internalModel.JobPositions.length > 0 && this.selectedJobPosition == null) {
                this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            }
            this.getBlockGrades();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return {dificultyLevelPopup }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
